import { Flex, Grid } from "@chakra-ui/react";
import { PersonaDetalle } from "../schema/person.schema";
import { AppColors } from "@/styles/colors";
import dayjs from "dayjs";
import { SiblingFieldItem } from "@/components/common/section-components/card/SiblingFieldItem";
import { v4 } from "uuid";
import { NoDataSmall } from "@/components/common/section-components/NoDataSmall";

interface Props {
  personData: PersonaDetalle | null;
}

export const FamilyData = ({ personData }: Props) => {
  if (!personData?.familiares?.length) return <NoDataSmall />;
  return (
    <Flex
      flexDir="column"
      width="100%"
      paddingTop="30px"
      gap="16px"
      overflowY="auto"
      css={{
        "@media (max-width: 1350px) and (min-width: 1272px)": {
          maxWidth: "900px",
          height: "300px",
        },
        "@media (max-width: 1414px) and (min-width: 1351px)": {
          maxWidth: "1100px",
          height: "375px",
        },
        "@media (max-width: 1590px) and (min-width: 1415px)": {
          maxWidth: "1250px",
          height: "425px",
        },
        "@media (max-width: 1696px) and (min-width: 1591px)": {
          maxWidth: "1350px",
          height: "500px",
        },
        "@media (max-width: 1900px)": {
          maxWidth: "1500px",
          height: "575px",
        },
        "@media (min-width: 1901px)": {
          height: "600px",
        },
      }}
    >
      {personData?.familiares?.map((familiar) => (
        <Grid
          key={v4()}
          padding="30px"
          borderRadius="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
          templateColumns="repeat(4, 1fr)"
          gap="6"
          paddingTop="20px"
        >
          <SiblingFieldItem title="DNI" value={familiar?.dni} />
          <SiblingFieldItem title="Nombre" value={familiar?.nombre} />
          <SiblingFieldItem title="Apellido" value={familiar?.apellido} />
          <SiblingFieldItem title="CUIL" value={familiar?.cuit} />
          <SiblingFieldItem
            title="Fecha de nacimiento"
            value={
              familiar?.nacimiento
                ? dayjs(familiar?.nacimiento).format("DD/MM/YYYY")
                : null
            }
          />
          <SiblingFieldItem title="Apodo" value={familiar?.apodo} />
          <SiblingFieldItem
            title="Localidad de residencia"
            value={familiar?.localidad}
          />
          <SiblingFieldItem
            title="Actividad agropecuaria"
            value={familiar?.esProductor ? "Sí" : "No"}
          />
          <SiblingFieldItem
            title="Nivel de estudios"
            value={familiar?.nivelEstudio}
          />
          <SiblingFieldItem
            title="Estado civil"
            value={familiar?.estadoCivil}
          />
          <SiblingFieldItem title="Profesión" value={familiar?.profesion} />
          <SiblingFieldItem
            title="Relación con persona"
            value={familiar?.tipoRelacion}
          />
        </Grid>
      ))}
    </Flex>
  );
};
